module.exports = __webpack_public_path__ + "img/statistic-manual.63c763cb.png";